import { useEffect } from 'react'
import styled from 'styled-components'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { enGB, nb } from 'date-fns/locale'

const ImprovedDatePicker = ({
  selected,
  language = 'nb',
  onChange,
}: {
  selected: Date
  language?: 'nb' | 'enGb'
  onChange: (date: Date | false) => void
}) => {
  useEffect(() => {
    const locale = language === 'nb' ? nb : enGB
    registerLocale(language, locale)
    setDefaultLocale(language)
  }, [language])

  const handleRawChange = (event) => {
    const validDate = getValidDate(event?.target?.value)
    if (validDate) {
      onChange(validDate)
    }
  }

  const handleChange = (date) => {
    const validDate = getValidDate(date)
    if (validDate) {
      onChange(validDate)
    }
  }

  const getValidDate = (date) => {
    const inputDate = new Date(date)

    if (isNaN(inputDate.getTime())) return false
    const now = new Date()
    const isFutureMonth =
      inputDate.getFullYear() > now.getFullYear() ||
      (inputDate.getFullYear() === now.getFullYear() &&
        inputDate.getMonth() > now.getMonth())

    if (isFutureMonth) return false

    return inputDate
  }

  const handleBlur = (event) => {
    if (!getValidDate(event?.target?.value)) {
      onChange(selected)
    }
  }

  return (
    <DatePickerContainer>
      <DatePicker
        selected={selected}
        onChangeRaw={handleRawChange}
        onChange={handleChange}
        dateFormat="MM/yyyy"
        maxDate={new Date()}
        onBlur={handleBlur}
        showMonthYearPicker
      />
    </DatePickerContainer>
  )
}

export default ImprovedDatePicker

const DatePickerContainer = styled.div`
  .react-datepicker-wrapper .react-datepicker__input-container input {
    border: 1px solid var(--color-line);
    border-radius: 8px;
    padding: var(--spacing-small) var(--spacing-small);
    font-size: 12px;
  }

  .react-datepicker__tab-loop {
    .react-datepicker-popper .react-datepicker__triangle {
      ::after,
      ::before {
        border-bottom-color: var(--color-primary);
      }
    }

    .react-datepicker-popper .react-datepicker__navigation ::before {
      border-color: var(--color-white);
    }

    .react-datepicker__month-container {
      .react-datepicker__header {
        background-color: var(--color-primary);

        div {
          color: var(--color-white);
        }
      }
    }
    .react-datepicker__month-text {
      padding: 8px 12px; /* Adjust to your preference */
      border-radius: 4px;
      cursor: pointer;
    }

    .react-datepicker__month-text:hover {
      background-color: var(--color-primary-light); /* Optional hover effect */
    }

    .react-datepicker__month-text.react-datepicker__month--selected {
      background-color: var(--color-primary);
      color: var(--color-white);
    }

    .react-datepicker__day.react-datepicker__day--023.react-datepicker__day--selected {
      background-color: var(--color-primary);
    }
  }
`
